"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var Link_1 = __importDefault(require("atomicComponents/atoms/Text/Link"));
var SimpleNoWrap_1 = __importDefault(require("atomicComponents/atoms/Text/SimpleNoWrap"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var TooltipContent_1 = __importDefault(require("atomicComponents/molecules/Tooltips/TooltipContent"));
var StatusBadge = function (_a) {
    var status = _a.status, mapper = _a.mapper, item = _a.item, textProps = _a.textProps, children = _a.children, url = _a.url, target = _a.target, props = __rest(_a, ["status", "mapper", "item", "textProps", "children", "url", "target"]);
    var statusData = mapper[status];
    var icon = (statusData === null || statusData === void 0 ? void 0 : statusData.icon)
        ? (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: statusData === null || statusData === void 0 ? void 0 : statusData.icon, color: statusData === null || statusData === void 0 ? void 0 : statusData.iconColor, style: { width: 18, marginRight: 8 } })
        : (0, jsx_runtime_1.jsx)("img", { src: statusData.img, alt: statusData.text, style: { width: 20, marginRight: 9 } });
    var content = ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-block" }, props, { component: SimpleNoWrap_1.default }, { children: [url ? (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: { pathname: url }, href: url, target: target }, { children: icon })) : icon, (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "span" }, textProps, { children: statusData === null || statusData === void 0 ? void 0 : statusData.text })), children] })));
    var tooltipProps = typeof statusData.tooltip === 'function' ? item && statusData.tooltip(item) : statusData.tooltip;
    if (tooltipProps) {
        var description = tooltipProps.description, title = tooltipProps.title;
        var descriptionContent = !(description === null || description === void 0 ? void 0 : description.startsWith('MD:')) ? description : (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: description.replace(/^MD:/, '') });
        return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ placement: "bottom", variant: "dark", title: (0, jsx_runtime_1.jsx)(TooltipContent_1.default, { maxWidth: 226, description: descriptionContent, title: (0, jsx_runtime_1.jsx)("strong", { children: title !== null && title !== void 0 ? title : statusData.text }) }) }, { children: content })));
    }
    return content;
};
exports.default = StatusBadge;
